import { ApiData } from '../../hooks/useApiData';
import { AssetPack } from '../dto/AssetPack';
import { ApiPath } from '../../api/ApiPath';
import { useApiItems } from '../../hooks/useApiItems';

export function useAssetPacks(): ApiData<AssetPack[]> {
  return useApiItems<AssetPack>(ApiPath.AssetPacks);
}
